<script>
    import { createEventDispatcher } from 'svelte';
    
    export let entries = (localStorage.getItem('entries')) ? localStorage.getItem('entries'): 100;

    const dispatch = createEventDispatcher();

    let selectEntries = function(){
        localStorage.setItem('entries', entries);
        dispatch('change', { entries: entries });
    }
</script>

<div class="col-md-2 ">
    <label>
        Show 
        <select bind:value={entries} on:change={selectEntries} class="form-control" id="entriesSelector">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
        </select> 
        entries
    </label>
</div>

<style>
    #entriesSelector {
        display: inline-block;
        width: auto;
    }
</style>